/* eslint-disable @typescript-eslint/indent */
import styled from 'styled-components';

interface Props {
  readonly wasWatched?: boolean;
  readonly image?: string;
}

const VideoPlayButtonStyles = styled.div<Props>`
  height: 26.67px;
  width: ${({ wasWatched }: Props): string => (wasWatched ? '23px' : '20px')};
  background-size: ${({ wasWatched }: Props): string => (wasWatched ? '100% !important' : '10px 10.67px !important')};
  background-position: center !important;
  background-repeat: no-repeat !important;
  cursor: pointer;
  background: url(${({ image }: Props): string => image || 'https://cdn.memed.com.br/icons-onboarding/PNG/play.png'});
  padding: 0;
`;

export default VideoPlayButtonStyles;
